<template>
  <div class="">
    <div class="x-banner">
      <BANNER></BANNER>
      <NAVIGATION
        :data="navigationData"
        :currentPath="currentPath"
      ></NAVIGATION>
    </div>

    <div class="container-width jxky-nr mt50">
      <div class="title">研究生教育</div>
      <!-- 科室  -->
      <section class="department-navigation">
        <div class="container-width">
          <ul class="ulPartList">
            <li
              class="li"
              v-for="(item, index) in xuekeData"
              :key="index"
              @click="goXueke(item)"
            >
              <a class="wh_dot">{{ item.name }}</a>
            </li>
          </ul>
          <div class="clear"></div>
        </div>
      </section>
    </div>
    <div class="container-width x-introduce mt50">
      <div class="title mt50">学术交流</div>
      <div class="mt50">
        <ul class="xx1_lb huli">
          <li v-for="(item, index) in xueshuList" :key="index">
            <a @click="goArticle(item)" :title="item.title">{{ item.title }}</a>
            <span class="zt_9d">{{ item.releaseDate }}</span>
          </li>
        </ul>
      </div>
    </div>
    <div class="t-block container-width mt50">
      <ul class="">
        <li>
          <a a href="/jxky/zazhi">
            <i class="iconfont icon-zazhiqikan"></i>
            <div>
              <h4>承办杂志</h4>
              <span>查看详情</span>
            </div>
          </a>
        </li>
        <li>
          <a a href="/jxky/zdsys">
            <i class="iconfont icon-dc-icon-guojiazhongdianshiyanshi"></i>
            <div>
              <h4>科技创新平台</h4>
              <span>查看详情</span>
            </div>
          </a>
        </li>
        <li>
          <a a href="/jxky/llwyh">
            <i class="iconfont icon-lunliweiyuanhui"></i>
            <div class="">
              <h4>伦理委员会</h4>
              <span>查看详情</span>
            </div>
          </a>
        </li>
        <li>
          <a a href="/jxky/ywlcsyjg">
            <i class="iconfont icon-yaowufenxi"></i>
            <div class="">
              <h4>药物临床试验机构</h4>
              <span>查看详情</span>
            </div>
          </a>
        </li>
      </ul>
    </div>
    <div class="mt50"></div>
  </div>
</template>
<script>
import service from "../../service/jxky";
import BANNER from "../../components/banner/jxky";
import { jxkyNavDic } from "../../const/navigationData";
export default {
  name: "JXKY",
  data() {
    return {
      pageIndex: 1,
      pageSize: window.screen.width < 720 ? 6 : 10,
      totalPages: 1,
      currentPage: 1,
      list: [],
      total: 0,
      navigationData: jxkyNavDic,
      currentPath: "/jxky/home",
      xueshuList: [],
      xuekeData: [],
    };
  },
  components: {
    BANNER,
  },
  computed: {},
  created() {
    this.init();
    this.getXueshuData();
    this.getXuekeData();
  },
  beforeMount() {},
  methods: {
    init() {
      let parmes = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        isshow: 1,
      };
      service.getYanjiuList(parmes, (res) => {
        if (res.content.length) {
          res.content.map((item) => {
            item.releaseDate = item.releaseDate
              ? item.releaseDate.substr(0, 10)
              : "";
          });
        }
        this.totalPages = parseInt(res.totalPages) || 0;
        this.total = res.totalElements;
        this.list = res.content || [];
      });
    },

    getXueshuData() {
      let parmes = {
        pageIndex: 1,
        pageSize: window.screen.width < 720 ? 6 : 10,
        isshow: 1,
      };
      service.getXueshuList(parmes, (res) => {
        if (res.content.length) {
          res.content.map((item) => {
            item.releaseDate = item.releaseDate
              ? item.releaseDate.substr(0, 10)
              : "";
          });
        }
        this.xueshuList = res.content || [];
      });
    },
    getXuekeData() {
      service.getwzGraduateSubList({}, (res) => {
        this.xuekeData = res || [];
      });
    },
    goArticle(e) {
      let parmes = {
        id: e.id,
      };

      if (e.url && e.url.length) {
        window.open(e.url, "_blank");
      } else {
        this.$router.push({
          path: "/jxky/xueshu/article",
          query: parmes,
        });
      }
    },
    togglePage(indexPage) {
      this.pageIndex = indexPage;
      this.init();
    },
    goXueke(e) {
      let articleId = e.id || 0;
      let name = e.name || 0;
      const { href } = this.$router.resolve({
        path: `/jxky/yanjiusheng/xueke`,
        query: {
          id: `${articleId}`,
          xueke: `${name}`,
        },
      });
      window.open(href, "_self");
    },
  },
  mounted() {},
  watch: {},
};
</script>

<style lang="scss" scoped>
.title {
  margin-top: 30px;
  font-size: 1.6rem;
  font-weight: bold;
  text-align: center;
}
.t-block {
  ul {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-column-gap: 30px;
    li {
      transition: all 0.5s;
      height: 130px;
      background-color: #fff;
      box-shadow: 4px 4px 24px -10px rgba (51, 51, 51, 0.2),
         -4px -4px 24px -10px rgba (51, 51, 51, 0.2);
      border: 1px solid #ddd;
      border-bottom: 6px solid #00479d;

      a {
        height: 100%;
        display: -webkit-flex;
        display: flex;
        -webkit-justify-content: center;
        justify-content: center;

        -webkit-box-align: center;
        align-items: center;
        i {
          line-height: 134px;

          text-align: center;

          color: #00479d;
          font-size: 50px;
          margin-right: 25px;
        }
        i.icon-huaxueshiyan-  {
          font-size: 75px;
        }
        h4 {
          font-size: 1.4rem;
          color: #0f4469;
        }
        span {
          display: block;
          color: #00479d;
          font-size: 14px;
          text-decoration: underline;
          margin-top: 10px;
        }
      }
    }
  }
}

@media only screen and (max-width: 1080px) {
  .t-block {
    ul {
      grid-template-columns: repeat(2, 1fr);
      grid-column-gap: 20px;
      li {
        margin-bottom: 15px;
        a {
          -moz-flex-direction: column;
          -webkit-flex-direction: column;
          flex-direction: column;
          i {
            font-size: 30px;
            margin-right: 0px;
            line-height: 30px;
          }
          div {
            text-align: center;
            h4 {
              font-size: 1.1rem;
              color: #0f4469;
            }
            span {
              margin-top: 5px;
              font-size: 0.8rem;
            }
          }
        }
      }
    }
  }
}
</style>
